"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SummaryView = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
require("../../css/documentView.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SummaryView = exports.SummaryView = function SummaryView(_ref) {
  var summary = _ref.summary,
    loading = _ref.loading;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column",
    style: {
      gap: "15px"
    }
  }, loading ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
    size: 40
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "summary-container",
    style: {
      maxHeight: "40vh",
      overflow: "auto"
    }
  }, summary), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontStyle: "italic"
    }
  }, "This summary was generated using GenAI technologies. Please review to confirm accuracy.")));
};